import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import PlanCompatibilityMessage from 'marketplace-ui-common/compatibility/components/PlanCompatibilityMessage';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import useRequiredPlansForIntegrationFeatures from '../../hooks/useRequiredPlansForIntegrationFeatures';
import { getMissingCompatibilityRequirements } from '../../../installability/utils/featureCompatibilities';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlanCompatibility = ({
  appContext,
  features,
  integrationFeatures,
  installability,
  isOpsHubListing,
  onOpenFeatureCompatibilityModal,
  tiers,
  trackInteraction
}) => {
  const {
    hubInstallable
  } = installability || {};
  const {
    requiredPlans,
    compatibilityLoading,
    compatibilityError
  } = useRequiredPlansForIntegrationFeatures({
    appContext: appContext === 'admin-preview' ? 'public' : appContext,
    integrationFeatures: integrationFeatures || []
  });
  const integrationFeaturesRequiredPlans = requiredPlans;
  const featuresMissingCompatibilityRequirements = getMissingCompatibilityRequirements(features, installability);
  const {
    missingRequirements,
    noCompatibleFeatures
  } = useMemo(() => {
    let filteredRequirements = [];
    let allRequirementsCompatibilityNone = false;
    if (features !== null && features !== void 0 && features.length) {
      filteredRequirements = featuresMissingCompatibilityRequirements.filter(requirement => !!requirement);
      // If all features have blocking compatibility requirements
      // we want to show COMPATIBLE_NONE as the top-level compatibility message
      allRequirementsCompatibilityNone = filteredRequirements.length === features.length && filteredRequirements.every(
      // USER_CONDITIONAL_SCOPE shows as COMPATIBLE_SOME
      requirement => requirement !== 'USER_CONDITIONAL_SCOPE');
    } else {
      filteredRequirements = integrationFeaturesRequiredPlans === null || integrationFeaturesRequiredPlans === void 0 ? void 0 : integrationFeaturesRequiredPlans.filter(plan => !!plan);
    }
    return {
      missingRequirements: filteredRequirements,
      noCompatibleFeatures: allRequirementsCompatibilityNone
    };
  }, [features, featuresMissingCompatibilityRequirements, integrationFeaturesRequiredPlans]);
  const featureCompatibilityStatus = getDataFetchingClientRequestState(compatibilityError, compatibilityLoading);
  const compatibilityType = useMemo(() => {
    if (!hubInstallable || noCompatibleFeatures) {
      return 'COMPATIBLE_NONE';
    } else if (missingRequirements.length) {
      return 'COMPATIBLE_SOME';
    } else {
      return 'COMPATIBLE_ALL';
    }
  }, [hubInstallable, missingRequirements, noCompatibleFeatures]);
  const opsHubLoadingStatus = isOpsHubListing ? featureCompatibilityStatus : RequestState.SUCCEEDED;
  const pageLoadingStatus = appContext === 'app' && !installability ? RequestState.PENDING : opsHubLoadingStatus;
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: pageLoadingStatus,
    children: /*#__PURE__*/_jsx(PlanCompatibilityMessage, {
      appContext: appContext === 'admin-preview' ? 'public' : appContext,
      compatibilityType: compatibilityType,
      helpText: compatibilityType === 'COMPATIBLE_SOME' ? /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.detail.sidebar.requirements.compatibilityDisclaimer"
        })
      }) : undefined,
      onTrackInteraction: trackInteraction,
      onFeaturesLinkClick: () => onOpenFeatureCompatibilityModal(),
      hasFeatureLevelScopeInfo: isOpsHubListing || !!(features !== null && features !== void 0 && features.length),
      tiers: tiers
    })
  });
};